import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { FirestoreService } from 'src/services/firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private firebaseService: FirestoreService) {
  }

  canActivate() {
    if (sessionStorage.getItem('usuario')) {
      const user: any = JSON.parse(sessionStorage.getItem('usuario'));
      this.firebaseService.getUsuari(user.i.user.uid).subscribe(data => {
        const usuario: any = data.payload.data();
        if (usuario.perfil_usuar === 'Administrador') {
          return true;
        } else {
          this.router.navigate(['/home']);
          return false;
        }
      });
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
